export default "__VITE_ASSET__hwaNvFFt__"